import requestFunctions from "../../functions/requestFunctions";


export const state = {
  TRUNKS_PHONES_ITEM: {},
  TRUNKS_PHONES_LIST: [],
  TRUNKS_PHONES_TABLE_DATA: [],
  TRUNKS_PHONES_LIST_DATA: [],
  TRUNKS_PHONES_TOTAL_ROWS: 0
}

export const getters = {
  GET_TRUNKS_PHONES_ITEM: (state) => {
    return state.TRUNKS_PHONES_ITEM;
  },
  GET_TRUNKS_PHONES_LIST: (state) => {
    return state.TRUNKS_PHONES_LIST;
  },
  GET_TRUNKS_PHONES_TABLE_DATA: (state) => {
    return state.TRUNKS_PHONES_TABLE_DATA;
  },
  GET_TRUNKS_PHONES_LIST_DATA: (state) => {
    return state.TRUNKS_PHONES_LIST_DATA;
  },
  GET_TRUNKS_PHONES_TOTAL_ROWS: (state) => {
    return state.TRUNKS_PHONES_TOTAL_ROWS;
  }
}

export const mutations = {

  UPDATE_TRUNKS_PHONES_ITEM(state, item) {
    state.TRUNKS_PHONES_ITEM = item;
  },

  UPDATE_TRUNKS_PHONES_LIST(state, list) {

    state.TRUNKS_PHONES_LIST = list.data;

    state.TRUNKS_PHONES_TOTAL_ROWS = list.total;
    list = list.data;

    state.TRUNKS_PHONES_TABLE_DATA = [];
    state.TRUNKS_PHONES_LIST_DATA = [];

    list.forEach(el => {

      let status =  el.status;

      if(status === 'created')  { status = 'Новый' }
      if(status === 'connect')  { status = 'Подключение' }
      if(status === 'blocked')  { status = 'Заблокирован' }
      if(status === 'active')   { status = 'Активен' }
      if(status === 'busy')     { status = 'Занят' }
      if(status === 'disabled') { status = 'Отключен' }

      let fullname = '';
      let acc_name = '';

      if(el.user_id){
        if (el.profile_name3) { fullname = fullname + el.profile_name3 + ' '; }
        if (el.profile_name1) { fullname = fullname + el.profile_name1 + ' '; }
        if (el.profile_name2) { fullname = fullname + el.profile_name2 + ' '; }

        acc_name = el.account_number;

        if (acc_name !== '') {
          acc_name = acc_name + ', ';
        }
        acc_name = acc_name + el.user_phone;

        if (fullname !== '') {
          if (acc_name !== '') {
            acc_name = acc_name + ', ';
          }
          acc_name = acc_name + fullname;
        }
      }

      let qnt_calls = 0
      if(el.qnt_calls != null){
        qnt_calls = el.qnt_calls;
      }

      state.TRUNKS_PHONES_TABLE_DATA.push({
        'uuid' : el.uuid,
        'id' : el.id,
        'created_at': el.created_at,
        'updated_at': el.updated_at,
        'number' : el.number,
        'bot_name' : el.bot_name,
        'operator_name' : el.operator_name,
        'account_number': acc_name,
        'trunk_name' : el.trunk_name,
        'qnt_calls'  : qnt_calls,
        'qnt_fails'  : el.qnt_fails,
        'status'     : status
      });

      state.TRUNKS_PHONES_LIST_DATA.push({
        id: el.id,
        uuid: el.uuid,
        name: el.number,
        number: el.number,
        qnt_calls: el.qnt_calls,
        user_id: el.user_id
      });

    });
  },
}

export const actions = {

  async FETCH_TRUNKS_PHONES_ITEM({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/trunks/phones/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_TRUNKS_PHONES_ITEM', response.data);
      return response.data;
    }

  },

  async FETCH_TRUNKS_PHONES_LIST({ commit }, payload= {}) {

    let query_url = 'https://api.client.za-bota.com/v1/trunks/phones';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_TRUNKS_PHONES_LIST', response.data);
      return response.data;
    }

  },

  async FETCH_TRUNKS_PHONES_CREATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/trunks/phones';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_TRUNKS_PHONES_UPDATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/trunks/phones/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_TRUNKS_PHONES_DELETE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/trunks/phones/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

}